import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNew = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		width: 8,
		height: 2,
		x: 4,
		y: 7,
		fillRule: "evenodd"
	})
});
export default SvgNew;
